// extracted by mini-css-extract-plugin
module.exports = {"layout":"style_layout__d9gZt","layout-body":"style_layout-body__kZaN5"};